// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3qtee","text":"styles__text___3Jnnz","button":"styles__button___11uSh","input":"styles__input___3IFgg"};